var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n\t\t\t"+_vm._s(_vm.title)),_c('small',[_vm._v(_vm._s(_vm.sTitle))])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('router-view',{on:{"setHeader":_vm.setHeader}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e43465fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cnt-app/components/content.wrapper.vue
// module id = null
// module chunks = 